import {
  ItemTypeConsts,
  ItemTypeDisplayNames,
  ItemTypeRoutes,
} from 'client/util/Constants';
import { featureFlags } from 'client/store/modules/FeatureFlagsModule';
import NavPanelLinkListItem from 'client/components/NavPanel/NavPanelLinkListItem';
import iconAccount from 'img/icons/nav/icon-nav-account.svg';
import iconActiveDirectory from 'img/icons/nav/icon-nav-activedirectory.svg';
import iconChat from 'img/icons/nav/icon-nav-chat.svg';
import iconCommands from 'img/icons/nav/icon-nav-commands.svg';
import iconConditionalList from 'img/icons/nav/icon-nav-conditionallist.svg';
import iconConditionalPolicies from 'img/icons/nav/icon-nav-conditionalpolicies.svg';
import iconConfigurationGroups from 'img/icons/nav/icon-nav-configuration-groups.svg';
import iconDeviceGroups from 'img/icons/nav/icon-nav-device-groups.svg';
import iconDevices from 'img/icons/nav/icon-nav-devices.svg';
import iconDirectories from 'img/icons/nav/icon-nav-directories.svg';
import iconDirectoryInsights from 'img/icons/nav/icon-nav-insights-directory.svg';
import iconDiscover from 'img/icons/nav/icon-nav-discover.svg';
import iconGroups from 'img/icons/nav/icon-nav-groups.svg';
import iconHome from 'img/icons/nav/icon-nav-home.svg';
import iconHris from 'img/icons/nav/icon-nav-hris.svg';
import iconLdap from 'img/icons/nav/icon-nav-ldap.svg';
import iconMdm from 'img/icons/nav/icon-nav-mdm.svg';
import iconMfa from 'img/icons/nav/icon-nav-mfa.svg';
import iconOsManagement from 'img/icons/nav/icon-nav-os-management.svg';
import iconPasswordManager from 'img/icons/nav/icon-nav-password-manager.svg';
import iconPolicies from 'img/icons/nav/icon-nav-policies.svg';
import iconRadius from 'img/icons/nav/icon-nav-radius.svg';
import iconReports from 'img/icons/nav/icon-nav-reports.svg';
import iconSettings from 'img/icons/nav/icon-nav-settings.svg';
import iconSoftwareApps from 'img/icons/nav/icon-nav-softwareApps.svg';
import iconSso from 'img/icons/nav/icon-nav-sso.svg';
import iconUsers from 'img/icons/nav/icon-nav-users.svg';

const NavPanelLinkList = {
  accountLink: new NavPanelLinkListItem({
    title: 'Account',
    href: ItemTypeRoutes[ItemTypeConsts.account],
    imageComponent: iconAccount,
  }),
  activeDirectoryLink: new NavPanelLinkListItem({
    title: 'Active Directory',
    href: ItemTypeRoutes[ItemTypeConsts.activeDirectory],
    imageComponent: iconActiveDirectory,
  }),
  applicationsLink: new NavPanelLinkListItem({
    title: ItemTypeDisplayNames[ItemTypeConsts.applications],
    href: ItemTypeRoutes[ItemTypeConsts.application],
    imageComponent: iconSso,
  }),
  chatLink: new NavPanelLinkListItem({
    title: 'Chat',
    imageComponent: iconChat,
  }),
  cloudDirectoriesLink: new NavPanelLinkListItem({
    title: 'Cloud Directories',
    href: ItemTypeRoutes[ItemTypeConsts.cloudDirectory],
    imageComponent: iconDirectories,
  }),
  commandsLink: new NavPanelLinkListItem({
    href: ItemTypeRoutes[ItemTypeConsts.command],
    imageComponent: iconCommands,
    showForCommandRunners: true,
    title: 'Commands',
  }),
  conditionalListsLink: new NavPanelLinkListItem({
    title: 'Conditional Lists',
    href: '#/security/iplists',
    imageComponent: iconConditionalList,
  }),
  configurationGroupsLink: new NavPanelLinkListItem({
    title: 'Policy Groups',
    href: ItemTypeRoutes[ItemTypeConsts.configurationGroup],
    imageComponent: iconConfigurationGroups,
    isNew: true,
  }),
  conditionalPoliciesLink: new NavPanelLinkListItem({
    title: 'Conditional Policies',
    href: '#/security/authnpolicies',
    imageComponent: iconConditionalPolicies,
    featureId: 'zeroTrust',
  }),
  configurationsLink: new NavPanelLinkListItem({
    isNew: true,
    title: 'Policy Management',
    href: ItemTypeRoutes[ItemTypeConsts.configuration],
    imageComponent: iconPolicies,
    featureId: 'osPatchManagement',
  }),
  deviceGroupsLink: new NavPanelLinkListItem({
    title: 'Device Groups',
    href: ItemTypeRoutes[ItemTypeConsts.deviceGroup],
    imageComponent: iconDeviceGroups,
  }),
  devicesLink: new NavPanelLinkListItem({
    title: 'Devices',
    href: ItemTypeRoutes[ItemTypeConsts.device],
    imageComponent: iconDevices,
  }),
  directoryInsightsLink: new NavPanelLinkListItem({
    title: 'Directory',
    href: '#/insights',
    imageComponent: iconDirectoryInsights,
  }),
  discoverLink: new NavPanelLinkListItem({
    title: 'Discover',
    href: '#/discover',
    imageComponent: iconDiscover,
  }),
  homeLink: new NavPanelLinkListItem({
    title: 'Home',
    href: '#/home',
    imageComponent: iconHome,
  }),
  hrDirectoriesLink: new NavPanelLinkListItem({
    title: 'HR Directories',
    href: ItemTypeRoutes[ItemTypeConsts.hrDirectory],
    imageComponent: iconHris,
  }),
  identityProvidersLink: new NavPanelLinkListItem({
    featureFlag: featureFlags.identityProvidersMvp,
    title: 'Identity Providers',
    href: ItemTypeRoutes[ItemTypeConsts.identityProviders],
    imageComponent: iconHris,
  }),
  ldapLink: new NavPanelLinkListItem({
    title: 'LDAP',
    href: '#/ldap',
    imageComponent: iconLdap,
  }),
  mfaLink: new NavPanelLinkListItem({
    title: 'MFA Configurations',
    href: ItemTypeRoutes[ItemTypeConsts.settingsMfa],
    imageComponent: iconMfa,
  }),
  mdmLink: new NavPanelLinkListItem({
    title: 'MDM',
    href: ItemTypeRoutes[ItemTypeConsts.mdmSettings],
    imageComponent: iconMdm,
  }),
  osManagement: new NavPanelLinkListItem({
    featureFlag: 'osManagement',
    href: ItemTypeRoutes[ItemTypeConsts.osManagement],
    imageComponent: iconOsManagement,
    isNew: true,
    title: 'OS Management',
  }),
  passwordManagerLink: new NavPanelLinkListItem({
    title: ItemTypeDisplayNames[ItemTypeConsts.passwordManager],
    href: ItemTypeRoutes[ItemTypeConsts.passwordManager],
    imageComponent: iconPasswordManager,
    featureFlag: featureFlags.passwordManager,
    featureId: 'passwordManagement',
  }),
  pkiConsole: new NavPanelLinkListItem({
    featureFlag: featureFlags.pkiConsole,
    href: ItemTypeRoutes[ItemTypeConsts.certificates],
    // @todo Change icon when UX provides final designs.
    imageComponent: iconConditionalPolicies,
    title: 'Certificate Manager',
  }),
  softwareAppsLink: new NavPanelLinkListItem({
    title: 'Software Management',
    href: ItemTypeRoutes[ItemTypeConsts.softwareApps],
    imageComponent: iconSoftwareApps,
  }),
  radiusLink: new NavPanelLinkListItem({
    title: 'RADIUS',
    href: ItemTypeRoutes[ItemTypeConsts.radiusServer],
    imageComponent: iconRadius,
  }),
  reportsLink: new NavPanelLinkListItem({
    featureFlag: 'synthesizedReports',
    href: ItemTypeRoutes[ItemTypeConsts.reports],
    imageComponent: iconReports,
    title: ItemTypeDisplayNames[ItemTypeConsts.reports],
  }),
  settingsLink: new NavPanelLinkListItem({
    title: 'Settings',
    href: ItemTypeRoutes[ItemTypeConsts.settings],
    imageComponent: iconSettings,
  }),
  ssoAppsLink: new NavPanelLinkListItem({
    title: ItemTypeDisplayNames[ItemTypeConsts.ssoApplications],
    href: ItemTypeRoutes[ItemTypeConsts.application],
    imageComponent: iconSso,
  }),
  ssoLink: new NavPanelLinkListItem({
    title: ItemTypeDisplayNames[ItemTypeConsts.sso],
    href: ItemTypeRoutes[ItemTypeConsts.sso],
    imageComponent: iconSso,
  }),
  userGroupsLink: new NavPanelLinkListItem({
    title: 'User Groups',
    href: ItemTypeRoutes[ItemTypeConsts.userGroup],
    imageComponent: iconGroups,
  }),
  usersLink: new NavPanelLinkListItem({
    title: 'Users',
    href: ItemTypeRoutes[ItemTypeConsts.systemUser],
    imageComponent: iconUsers,
  }),
};

export default NavPanelLinkList;
